import { Button } from '@/components/ui/button'
import { useTheme } from '@/providers/ThemeProvider'
import { MoonIcon, SunIcon } from 'lucide-react'

/** Light/dark switch backed by our own ThemeProvider (no next-themes). */
export function ThemeToggle() {
  const { toggle } = useTheme()
  return (
    <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme">
      <SunIcon className="size-4 dark:hidden" />
      <MoonIcon className="hidden size-4 dark:block" />
    </Button>
  )
}
